import { color } from "style/constants";

export default {
  root: {
    "&$selected": {
      color: color.BLACK
    }
  }
};
